import React from 'react'
import { MarkerSvgProps } from './MarkerSvgProps'

export const VacanciesSvg = ({ style }: MarkerSvgProps) => {
  return (
    <svg
      width={32}
      height={40}
      style={style}
      viewBox="0 0 65 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.35" filter="url(#filter0_f_8284_162721)">
        <path
          d="M48.5 69C48.5 71.7614 41.3366 74 32.5 74C23.6634 74 16.5 71.7614 16.5 69C16.5 66.2386 23.6634 64 32.5 64C41.3366 64 48.5 66.2386 48.5 69Z"
          fill="black"
        />
      </g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5 4C7.18629 4 4.5 6.68629 4.5 10V52C4.5 55.3137 7.18629 58 10.5 58H24.3279C24.9738 58 25.58 58.3119 25.9554 58.8375L30.8725 65.7215C31.6702 66.8382 33.3298 66.8382 34.1275 65.7215L39.0446 58.8375C39.42 58.3119 40.0262 58 40.6721 58H54.5C57.8137 58 60.5 55.3137 60.5 52V10C60.5 6.68629 57.8137 4 54.5 4H10.5Z"
        fill="#0CB200"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.69922 10.0002C1.69922 5.14009 5.63911 1.2002 10.4992 1.2002H54.4992C59.3593 1.2002 63.2992 5.14009 63.2992 10.0002V52.0002C63.2992 56.8603 59.3593 60.8002 54.4992 60.8002H41.083L36.4051 67.3492C34.4908 70.0293 30.5076 70.0293 28.5933 67.3492L23.9154 60.8002H10.4992C5.63911 60.8002 1.69922 56.8603 1.69922 52.0002V10.0002ZM4.49922 10.0002C4.49922 6.68649 7.18551 4.0002 10.4992 4.0002H54.4992C57.8129 4.0002 60.4992 6.68649 60.4992 10.0002V52.0002C60.4992 55.3139 57.8129 58.0002 54.4992 58.0002H40.6713C40.0254 58.0002 39.4193 58.3121 39.0438 58.8377L34.1267 65.7217C33.329 66.8384 31.6694 66.8384 30.8717 65.7217L25.9546 58.8377C25.5792 58.3121 24.973 58.0002 24.3271 58.0002H10.4992C7.18551 58.0002 4.49922 55.3139 4.49922 52.0002V10.0002Z"
        fill="white"
      />
      <path
        d="M40.5 22C40.5 26.4183 36.9183 30 32.5 30C28.0817 30 24.5 26.4183 24.5 22C24.5 17.5817 28.0817 14 32.5 14C36.9183 14 40.5 17.5817 40.5 22Z"
        fill="white"
      />
      <path
        d="M24.5 36C24.5 32.6863 27.1863 30 30.5 30H34.5C37.8137 30 40.5 32.6863 40.5 36V48H24.5V36Z"
        fill="white"
      />
      <defs>
        <filter
          id="filter0_f_8284_162721"
          x="13.5"
          y="61"
          width="38"
          height="16"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="1.5"
            result="effect1_foregroundBlur_8284_162721"
          />
        </filter>
      </defs>
    </svg>
  )
}
